import { usePageFromCurrentRoute } from "./usePageFromCurrentRoute";
import { useRequestPageHistory } from "./useRequestPageHistory";
import { useRouteParams } from "./useRouteParams";

export const useRequestPageHistoryForCurrRoute = () => {
	const { documentId } = useRouteParams();
	const { pageMetadata } = usePageFromCurrentRoute();
	const pageId = pageMetadata?.id;
	const history = useRequestPageHistory(documentId, pageId);

	if (!pageMetadata) {
		return {
			...history,
			entries: [],
			selectedEntryId: null,
			selectHistoryEntry: async () => undefined,
			isLoading: true,
			isError: false,
			error: null,
		};
	}

	return history;
};
